import { z } from 'zod';
import { CustomErrorParams, CustomErrorType } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ageCategoriesCounterFieldsSchema } from '../../../../../components/form/hookFields';

export enum AgeCategoriesCountFormKeys {
    ageCategories = 'ageCategories',
    keepOldPrice = 'keepOldPrice',
}

export const ageCategoriesCounterFormSchema = z
    .object({
        [AgeCategoriesCountFormKeys.ageCategories]: ageCategoriesCounterFieldsSchema,
        [AgeCategoriesCountFormKeys.keepOldPrice]: z.boolean(),
    })
    .superRefine(({ ageCategories }, ctx) => {
        const personSum = Object.values(ageCategories).reduce((acc, item) => item + acc, 0);

        if (personSum === 0) {
            Object.keys(ageCategories).forEach((id) => {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    params: {
                        errorType: CustomErrorType.Other,
                        textKey: TextKey.NumberNotGreaterThanOrEqualToErrorMessage,
                        substitutes: { number: 1 },
                    } satisfies CustomErrorParams,
                    path: [AgeCategoriesCountFormKeys.ageCategories, id],
                    fatal: true,
                });
            });
        }
    });

export type AgeCategoriesCountFormValues = z.infer<typeof ageCategoriesCounterFormSchema>;
